/* eslint-disable react/prop-types */
import React, {
  useEffect, useState, useContext, useRef,
} from 'react';
import { useRouter } from 'next/router';
import BottomSheet from './BottomSheet';
import { ClearFilterIcon, MinusSVG, PlusSVG } from './icons/svgs';
// TODO
import { ToastContext } from '../../contexts/toast-context-with-provider';
import Spinner from '../../icons/spinner';
import { trackEvent } from '../../utils/analytics';
import EventNames from '../../utils/event-name-constants';
// import { trackEvent } from '../../utils/analytics';

function FilterBottomSheet({
  filterData, isLoad, onApplyFilters, queryPareams,
}) {
  const [isBottomSheetOpen, setBottomSheetOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState('');
  const [selectedOptions, setSelectedOptions] = useState();
  const [appliedFilters, setAppliedFilters] = useState({}); // Track applied filters separately
  const [openAccordions, setOpenAccordions] = useState({});
  const [loader, setLoader] = useState(false);
  const { FILTER_APPLIED } = EventNames;
  const router = useRouter();
  const accordionsInitialized = useRef(false);

  const handleOpen = () => setBottomSheetOpen(true);
  const handleClose = () => {
    setBottomSheetOpen(false);
  };
  const { showToast } = useContext(ToastContext);

  const updateAllQueryParam = () => {
    const url = new URL(window.location.href);
    Object.entries(selectedOptions).forEach((item) => {
      if (item[1] !== '') {
        url.searchParams.set(item[0], item[1]);
      }
    });
    // Now push it to history without page reload
    router.replace(url.toString(), undefined, { shallow: true });
    // window.history.pushState({}, '', url); // replace this with native router method for resolve browser back button issue
  };

  // const clearParams = () => window.history.pushState(null, '', window.location.origin + window.location.pathname);
  const clearParamsKeepScope = () => { // function for keep scope param
    const url = new URL(window.location.href);
    const scopeValue = router?.query?.scope || url.searchParams.get('scope');
    url.search = '';
    if (scopeValue) {
      url.searchParams.set('scope', scopeValue);
    }
    // window.history.pushState(null, '', url.toString());
    router.replace(url.toString(), undefined, { shallow: true });
  };
  const clearParams = () => {
    if (router.query.scope || new URL(window.location.href).searchParams.get('scope')) {
      clearParamsKeepScope();
    } else {
      router.replace(router.pathname, undefined, { shallow: true });
    }
  };

  const handleFilterChange = (filterName, value) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [filterName]: value,
    }));
    // updateQueryParam(filterName, value);
  };

  const toggleAccordion = (filterName) => {
    setOpenAccordions((prev) => ({
      ...prev, // previous state for open accordion
      [filterName]: !prev[filterName],
    }));
  };
  const isAllFilterEmpty = () => {
    const res = Object.values(selectedOptions).every((val) => val === '');
    return !!res;
  };

  const handleClearFilters = () => {
    // console.log('filterData ', filterData);
    if (isAllFilterEmpty()) {
      showToast('No Filters to clear.');
      return;
    }
    clearParams();
    setSelectedFilter(filterData?.[0]?.key);
    // setOpenAccordions({});
    setSelectedOptions({});
    setAppliedFilters({}); // Clear applied filters too
    onApplyFilters({});
    handleClose();
  };

  const manageFilterOptions = (options) => {
    const newOptions = { ...options };

    // if (newOptions.mode === 'Online') {
    //   newOptions.centreId = '';
    // }
    // if (newOptions.tagId === 'all') {
    //   newOptions.tagId = '';
    // }
    newOptions.tagId = '';

    return newOptions;
  };

  // Helper function to get selected filter chips
  const getSelectedFilterChips = () => {
    if (!appliedFilters || !filterData) return [];

    const chips = [];
    Object.entries(appliedFilters).forEach(([key, value]) => {
      if (value && value !== '') {
        const filter = filterData.find((f) => f.key === key);
        if (filter && filter.options) {
          const option = filter.options.find((opt) => opt.id === value);
          if (option) {
            chips.push({
              filterKey: key,
              filterValue: value,
              displayName: option.name,
            });
          }
        }
      }
    });

    return chips;
  };

  // Handler to remove individual filter
  const handleRemoveFilter = (filterKey) => {
    // Update both selected and applied filters
    const updatedOptions = { ...selectedOptions };
    updatedOptions[filterKey] = '';
    setSelectedOptions(updatedOptions);

    const updatedAppliedFilters = { ...appliedFilters };
    updatedAppliedFilters[filterKey] = '';
    setAppliedFilters(updatedAppliedFilters);

    // Update URL params - remove the specific param
    const url = new URL(window.location.href);
    url.searchParams.delete(filterKey);
    router.replace(url.toString(), undefined, { shallow: true });

    // Apply the updated filters
    const managedOptions = manageFilterOptions(updatedAppliedFilters);
    onApplyFilters(managedOptions);
  };

  // Helper function to get count of active filters
  const getActiveFiltersCount = () => {
    if (!appliedFilters) return 0;
    return Object.values(appliedFilters).filter((value) => value && value !== '').length;
  };

  // Helper function to check if a filter has an active value
  const isFilterActive = (filterKey) => {
    if (!appliedFilters) return false;
    return !!(appliedFilters[filterKey] && appliedFilters[filterKey] !== '');
  };

  // const filterSOptionsExpanded = () => {
  //   if (filterData) {
  //     // eslint-disable-next-line array-callback-return
  //     filterData?.map((item) => {
  //       setOpenAccordions((prev) => ({
  //         ...prev, // previous state for open accordion
  //         [item.name]: true,
  //       }));
  //     });
  //   }
  // };

  const getEventPayload = () => {
    const payload = {};
    payload.mode = selectedOptions?.mode || '';
    payload.language = selectedOptions?.language || '';

    if (selectedOptions?.centreId) {
      const centreFilter = filterData.find((f) => f.key === 'centreId');
      const centreOption = centreFilter?.options.find((opt) => opt.id === selectedOptions.centreId);
      payload.centre = centreOption ? centreOption.name : '';
    } else {
      payload.centre = '';
    }

    if (selectedOptions?.examId) {
      const examFilter = filterData.find((f) => f.key === 'examId');
      const examOption = examFilter?.options.find((opt) => opt.id === selectedOptions.examId);
      payload.exam = examOption ? examOption.name : '';
    } else {
      payload.exam = '';
    }

    return payload;
  };

  const handleApplyFilters = () => {
    if (isAllFilterEmpty()) {
      showToast('Please select filters.');
    } else {
      setLoader(true);
      updateAllQueryParam();
      const updatedOptions = manageFilterOptions(selectedOptions);
      setSelectedOptions(updatedOptions); // still keep your state updated
      setAppliedFilters(updatedOptions); // Update applied filters when Apply is clicked
      onApplyFilters(updatedOptions);
      const eventPayload = getEventPayload();
      trackEvent(FILTER_APPLIED, eventPayload);
      handleClose();
      setTimeout(() => {
        setLoader(false);
      }, 1000);
    }

    // setTimeout(() => {
    //   onApplyFilters(updatedOptions); // use updated object here
    //   // clearParams();
    //   // setOpenAccordions({});
    //   handleClose(); // Close the bottom sheet
    // }, 100);

    // filterSOptionsExpanded();
  };

  useEffect(() => {
    const initialFilters = {
      mode: queryPareams.mode || '',
      centreId: queryPareams.centreId || '',
      tag: queryPareams.tag || '',
      examId: queryPareams.examId || '',
      language: queryPareams.language || '',
      streamId: queryPareams?.streamId || '',
      type: queryPareams?.type || '',
    };
    setSelectedOptions(initialFilters);
    setAppliedFilters(initialFilters); // Also set applied filters from URL params
  }, [queryPareams]);

  useEffect(() => {
    if (filterData && !accordionsInitialized.current) {
      accordionsInitialized.current = true;
      // Only open streamId accordion when streamId is present from user
      if (queryPareams?.streamId) {
        const streamIdFilter = filterData.find((filter) => filter.key === 'streamId');
        if (streamIdFilter) {
          setOpenAccordions({
            [streamIdFilter.name]: true,
          });
        }
      }
    }
  }, [filterData]);

  useEffect(() => {
    setSelectedFilter(filterData?.[0]?.key);
  }, [isBottomSheetOpen]);
  // if (isLoad) return <p>Loading...</p>;
  if (isLoad) {
    return (

      <div className="hidden lg:block top-4 left-4 bg-white rounded-lg border w-full border-[#B8E5FF]">
        <div className="2xl:text-base xl:text-sm text-sm font-medium text-center flex justify-between p-4">
          <div className="w-20 h-5 bg-gray-200 rounded animate-pulse p-2" />
          <div className="w-5 h-5 bg-gray-200 rounded-full animate-pulse" />
        </div>

        {/* Skeleton Accordions */}
        <div className="px-4 lg:max-h-[calc(100vh-50vh)] overflow-hidden overflow-y-auto">
          {[...Array(5)].map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index} className="border-b last:border-b-0 py-4" style={{ borderColor: '#B8E5FF' }}>
              <div className="flex justify-between items-center p-4">
                <div className="w-32 h-4 bg-gray-200 rounded animate-pulse" />
                <div className="w-4 h-4 bg-gray-200 rounded-full animate-pulse" />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
  return (
    <div>
      {
      !isLoad
    && (
    <div className="flex flex-col items-center  lg:sticky lg:max-h-screen lg:top-16">
      {/* Card Header */}
      <div className="hidden lg:block top-4 left-4 bg-white rounded-lg border w-full" style={{ borderColor: '#B8E5FF' }}>
        <div className="2xl:text-base xl:text-sm text-sm font-medium text-center flex justify-between p-4">
          <h2 className="2xl:text-base xl:text-sm text-sm font-semibold text-gray-800 justify-center p-2">Filters</h2>
          <span onClick={handleClearFilters} className="cursor-pointer"><ClearFilterIcon /></span>
        </div>

        {/* Selected Filter Chips */}
        {getSelectedFilterChips().length > 0 && (
          <div className="px-4 pb-3 flex flex-wrap gap-2">
            {getSelectedFilterChips().map((chip) => (
              <div
                key={chip.filterKey}
                className="inline-flex items-center gap-2 bg-white border rounded-full px-3 py-1.5 text-sm"
                style={{ borderColor: '#D1D5DB' }}
              >
                <span className="text-gray-700">{chip.displayName}</span>
                <button
                  onClick={() => handleRemoveFilter(chip.filterKey)}
                  className="text-gray-500 hover:text-gray-700 focus:outline-none"
                  type="button"
                  aria-label={`Remove ${chip.displayName} filter`}
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        )}

        {/* Filters Accordion */}
        <div className="px-4 lg:max-h-[calc(100vh-50vh)] overflow-hidden overflow-y-auto">
          {filterData?.map((filter, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index} className="border-b last:border-b-0" style={{ borderColor: '#B8E5FF' }}>
              {/* Accordion Header */}
              <div
                className="flex justify-between items-center cursor-pointer p-4 "
                onClick={() => toggleAccordion(filter.name)}
              >
                <span
                  className={`2xl:text-base xl:text-sm md:text-sm text-sm 
                  ${openAccordions[filter.name] ? 'font-semibold' : 'font-normal'}`}
                  style={{ color: openAccordions[filter.name] ? '#0267B1' : '#334155' }}
                >
                  {filter.name}
                </span>
                {openAccordions[filter.name] ? <MinusSVG /> : <PlusSVG />}
              </div>

              {/* Accordion Content */}
              {openAccordions[filter.name] && (
              <div className="pb-4 pt-1">
                {filter.options.map((option, idx) => (
                  <div
                      // eslint-disable-next-line react/no-array-index-key
                    key={idx}
                    className="py-2 px-4"
                  >
                    <div className="flex space-x-2 items-center " onClick={() => handleFilterChange(filter.key, option.id)}>
                      <input
                        type="radio"
                        id={`${filter.key}-${option.id}, _${selectedOptions[filter.key]}`}
                        name={filter.key}
                        value={option.id}
                        checked={selectedOptions[filter.key] === option.id}
                        onChange={() => handleFilterChange(filter.key, option.id)}
                        className="h-6  text-blue-500 w-[8%]"
                      />
                      <label
                        htmlFor={`${filter.name}-${option}`}
                        className={`lg:text-sm text-sm w-[90%] text-greyFont ${selectedOptions[filter.key] === option.id ? 'font-semibold' : 'font-normal'}`}
                      >
                        {option.name}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
              )}
            </div>
          ))}
        </div>
        <div className="p-4 flex justify-center text-center">
          <button
            onClick={handleApplyFilters}
            className="text-sm bg-tabBlue flex justify-center text-white px-3 py-2 rounded-md hover:bg-tabBlue w-[75%]"
            type="submit"
          >

            {loader ? (<Spinner extraClasses="text-center" />) : 'Apply'}
            {/* <Spinner extraClasses="" /> */}
          </button>
        </div>
      </div>
      {/* Mweb Sticky Filter Button */}
      <div className="fixed bottom-14 text-white py-3 text-center lg:hidden z-[2]">
        <button type="button" className="flex items-center justify-center bg-[#154D76] text-white rounded-full px-6 py-3 shadow-md hover:bg-[#154D76]-800 focus:outline-none focus:ring-2 focus:ring-[#154D76]-500 relative" onClick={handleOpen}>
          {/* <span className="mr-2"> */}
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.833 16.041h4.584M20.167 5.958h-4.584M11.917 16.041h8.25M10.083 5.958h-8.25M9.167 18.7a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5zM12.833 8.616a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5z" stroke="#fff" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
          </svg>

          {/* </span> */}
          <span className="px-2 text-base">Filters</span>

          {/* Filter Count Badge */}
          {getActiveFiltersCount() > 0 && (
            <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full h-6 w-6 flex items-center justify-center">
              {getActiveFiltersCount()}
            </span>
          )}
        </button>
      </div>

      {/* Bottom Sheet */}
      {isBottomSheetOpen
        && (
        <BottomSheet
          isOpen={isBottomSheetOpen}
          onClose={handleClose}
          clearFilter={handleClearFilters}
          applyFilters={handleApplyFilters}
          title="Filters"
        >
          <div className="flex flex-row h-full">
            <div className="w-1/3 py-4 border-r overflow-y-auto md:text-base text-sm" style={{ borderColor: '#939393' }}>
              {filterData.map((filter, index) => (
                <div
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  className={`py-2 px-4 cursor-pointer mb-4 flex items-center justify-between border-r-[6px] ${selectedFilter === filter.key
                    ? 'border-solid border-red-600 bg-blue-100 text-customBlue font-semibold'
                    : 'bg-white text-gray-400 font-light border-transparent'
                  }`}
                  onClick={() => setSelectedFilter(filter.key)}
                >
                  <span>{filter.name}</span>
                  {/* Blue dot indicator for active filters */}
                  {isFilterActive(filter.key) && (
                    <span className="w-2 h-2 bg-blue-500 rounded-full flex-shrink-0" />
                  )}
                </div>
              ))}
            </div>

            {/* Right Column: Filter Options */}
            <div className="w-2/3 p-4 overflow-y-auto text-base lg:max-h-auto max-h-[76vh]">
              {/* <h3 className="font-semibold text-lg mb-4">{selectedFilter}</h3> */}
              <div className="space-y-2">
                {filterData
                  .find((filter) => filter.key === selectedFilter)
                  ?.options.map((option, idx) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={idx} className="flex items-center space-x-2 py-2" onClick={() => handleFilterChange(selectedFilter, option.id)}>
                      <input
                        type="radio"
                        id={`${selectedFilter}-${option.id}`}
                        name={selectedFilter}
                        value={option.id}
                        checked={selectedOptions[selectedFilter] === option.id}
                        onChange={() => handleFilterChange(selectedFilter, option.id)}
                        className="h-6 w-6 text-blue-500"
                      />
                      <label
                        htmlFor={`${selectedFilter}-${option.id}`}
                        className={` ${selectedOptions[selectedFilter] === option.id
                          ? 'font-semibold'
                          : 'font-light '
                        } font-base`}
                        style={{ color: '#3E494C' }}
                      >
                        {option.name}
                      </label>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </BottomSheet>
        )}
    </div>
    )
      }
    </div>
  );
}

export default FilterBottomSheet;
